import { Info } from 'lucide-react';
import { cn } from '@/shared/utils/cn';
import { GRADIENT_BANNER } from '../../shared/analytics-constants';
import type { FpReferralValue } from '../../../../types/analytics.types';

type ReferralValueBannerProps = {
  value: FpReferralValue;
  activeAdvisors: number;
};

export const ReferralValueBanner = ({ value, activeAdvisors }: ReferralValueBannerProps) => {
  const positive = value.monthOverMonthGrowth >= 0;

  return (
    <div
      className="rounded-xl p-6 text-white"
      style={{
        background: `linear-gradient(135deg, ${GRADIENT_BANNER.from} 0%, ${GRADIENT_BANNER.to} 100%)`,
      }}
    >
      <div className="flex items-start justify-between gap-6">
        <div>
          <div className="flex items-center gap-1.5">
            <h3 className="text-lg font-semibold">Advisor-Driven Referral Value</h3>
            <Info className="w-4 h-4 opacity-70" />
          </div>
          <p className="text-sm text-white/70 mt-1 max-w-md">
            Total client referrals advisors have routed into the bQuest network
          </p>
          <div className="flex items-center gap-2 mt-3 text-sm">
            <span
              className={cn('font-semibold', positive ? 'text-emerald-300' : 'text-red-300')}
            >
              {positive ? '↑' : '↓'} {Math.abs(value.monthOverMonthGrowth)}% MoM
            </span>
            <span className="text-white/60">vs prev. period</span>
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-1 mt-2 text-sm text-white/70">
            <span>
              Active advisors: <span className="text-white font-medium">{activeAdvisors}</span>
            </span>
            <span>
              Providers engaged:{' '}
              <span className="text-white font-medium">{value.providersEngaged}</span>
            </span>
          </div>
        </div>
        <div className="text-right flex-shrink-0">
          <div className="text-4xl lg:text-5xl font-bold">{value.total.toLocaleString('en-US')}</div>
          <div className="text-sm text-white/70 mt-1">Advisor-driven referrals</div>
        </div>
      </div>
    </div>
  );
};
